import { render, staticRenderFns } from "./WatchPage.vue?vue&type=template&id=9a7947a8&"
import script from "./WatchPage.vue?vue&type=script&lang=js&"
export * from "./WatchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports